exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backToTop[data-v-1f3e4440]{width:32px;height:32px;background:rgba(0,0,0,.4);border-radius:50%;position:fixed;bottom:90px;right:30px;cursor:pointer;z-index:1030;line-height:32px;transform:translateX(100px);opacity:0;transition:all 1s}.backToTop.show[data-v-1f3e4440]{opacity:1;transform:translateX(0)}.backToTop i[data-v-1f3e4440]{color:#fff;font-size:20px;display:block;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f3e4440","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/BackToTop/index.vue
// module id = 726
// module chunks = 0